import { IonCard, IonCardContent, IonCardHeader } from "@ionic/react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithNavigation from "../../hoc/with-navigation";
import TvmForm from "../../components/common/tvm-form";
import { useSystem } from "../../store/system";
import { useEffect } from "react";
import { TvmFormSubmitResult } from "../../components/common/tvm-form/form-definition";
import TowCableResults from "../../components/tow-cable-results";

import "./styles.css";


const FORM_ID = "towCable";

interface TowCableFormData {
	mainPower: number;
	trawlSpeed: number;
	_evaluationResult: Result;
}

interface Result {
	__cond: any;
}

const TowCable = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	const updateResults = (data: TvmFormSubmitResult<TowCableFormData>) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints.htmlDef,
				}}
				preventGoBack={false}
				text={t("system.towCable.title")}
			>
				<div className="form">
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.towCable.title")}
									systemName={systemId}
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							<IonCard>
								{!systemStore.formResult?.__cond?.result && (
									<IonCardHeader>
										{t("system.towCable.mainPowerOutOfRange")}
									</IonCardHeader>
								)}
								{systemStore.formResult?.__cond?.result && (
									<IonCardContent>
										<TowCableResults
											results={systemStore.formResult?.__cond?.result}
										/>
									</IonCardContent>
								)}
							</IonCard>
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default TowCable;
